// @ts-nocheck
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'lib-flexible/flexible.js'
import i18n from '@/i18n'
import axios from 'axios'
import store from '@/store'
import 'vant/lib/icon/local.css'
import {
  NavBar,
  DropdownMenu,
  DropdownItem,
  Field,
  List,
  Search,
  SwipeCell,
  Button,
  Collapse,
  CollapseItem,
  Sticky,
  Cell,
  CellGroup,
  Image as VanImage,
  Tag,
  Dialog,
  Toast,
  Switch,
  PullRefresh,
  Divider,
  Icon,
  skeleton,
  ActionSheet,
  RadioGroup,
  Radio
} from 'vant';
import {
  Tree,
  Timeline,
  TimelineItem
} from 'element-ui'
import './styles/index.css'
import { setToken, getToken, setHost, getPortalToken, setPortalToken, getUrl } from './lib/storage'
import { parseUrl } from './lib/util'

Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(NavBar)
Vue.use(Field)
Vue.use(List)
Vue.use(Search)
Vue.use(SwipeCell)
Vue.use(Button)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Sticky)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(VanImage)
Vue.use(Dialog)
Vue.use(Tag)
Vue.use(Tree)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.use(Toast)
Vue.use(Switch)
Vue.use(PullRefresh)
Vue.use(Divider)
Vue.use(Icon)
Vue.use(skeleton)
Vue.use(ActionSheet)
Vue.use(RadioGroup);
Vue.use(Radio);

Vue.config.productionTip = false

router.beforeEach(async (to, from, next) => {

  if (!getToken()) {
    // if (to.path !== '/login') {
    //   return next('/login')
    // }else{
    //   next()
    // }
    try {
      let st = getPortalToken()
      setHost(`${getUrl}`);
      Toast.loading('loading...')
      if (!st) {
        st = parseUrl('st')
        setPortalToken(st)
      }
      const apiUrl = `${getUrl}/camapi/auth/account/getSessionUser`;
      const {
        data: {
          data: { empNo: username },
        },
      } = await axios.post(
        apiUrl,
        { clientName: 'FUSON-BPM' },
        {
          headers: {
            Authorization: st
          },
        }
      );
      const {
        data: {
          data: { access_token: flowToken }
        }
      } = await axios.post('/api/sso/login', { username })
      Toast.clear()
      setToken(flowToken)
      if (to.path == '/WaitFor' || to.path == '/detail') {
        next();
      } else {
        return next('/WaitFor');
      }
    } catch (e) {
      // alert(e)
      setPortalToken('')
      setToken('')
      Toast.fail({
        onClose: () => router.go(-1),
        duration: 800,
        message: '用户登录失败'
      })
    }
  } else {
    if (to.path !== '/WaitFor' && to.path !== '/detail') {
      return next('/WaitFor');
    } else {
      next();
    }
    // return next('/WaitFor');
  }
})

/* eslint-disable no-new */
new Vue({
  i18n,
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js